import React from 'react';
export function BonosSection() {
  const bonos = [{
    num: 1,
    title: '100 DISEÑOS LISTOS PARA BORDAR',
    desc: 'Flores, animales, frases, decoración boho e infantil. Solo imprimir y comenzar.',
    value: '$12.000'
  }, {
    num: 2,
    title: 'RETRATOS DE MASCOTAS EN PUNCH NEEDLE',
    desc: 'Aprendé a crear uno de los productos personalizados más buscados.',
    value: '$15.000'
  }, {
    num: 3,
    title: 'GUÍA DE PROVEEDORES Y MATERIALES',
    desc: 'Dónde conseguir agujas, telas, bastidores, lanas y herramientas.',
    value: '$10.000'
  }, {
    num: 4,
    title: 'CÓMO VENDER POR REDES SOCIALES',
    desc: 'Instagram, Facebook, TikTok y WhatsApp aunque empieces desde cero.',
    value: '$15.000'
  }];
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <div className="text-center mb-5" data-id="element-37">
          <h2 className="font-heading text-2xl md:text-3xl text-brand-dark font-bold" data-id="element-38">
            🎁 4 BONOS EXCLUSIVOS INCLUIDOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-39">
          {bonos.map((bono, i) => <div key={i} className="bg-brand-cream/50 rounded-2xl p-4 md:p-5 border border-brand-pink/20 relative overflow-hidden group hover:border-brand-pink transition-colors" data-id="element-40">
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-brand-pink/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-41"></div>

              <div className="relative z-10" data-id="element-42">
                <div className="inline-block bg-brand-pink text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-43">
                  BONUS {bono.num}
                </div>
                <h3 className="font-bold text-base md:text-lg text-brand-dark mb-1" data-id="element-44">
                  {bono.title}
                </h3>
                <p className="text-brand-text mb-3 text-sm" data-id="element-45">{bono.desc}</p>

                <div className="flex items-center gap-3" data-id="element-46">
                  <span className="text-gray-400 line-through font-medium text-sm" data-id="element-47">
                    {bono.value}
                  </span>
                  <span className="bg-green-100 text-green-700 font-bold px-2.5 py-0.5 rounded-lg text-sm" data-id="element-48">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-purple text-white rounded-2xl p-5 md:p-6 text-center max-w-2xl mx-auto shadow-soft" data-id="element-49">
          <p className="text-sm md:text-base mb-1 text-brand-cream/80" data-id="element-50">
            Valor total de los bonos:
          </p>
          <p className="text-2xl font-bold line-through text-brand-cream/50 mb-1" data-id="element-51">
            $52.000
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-pink drop-shadow-md" data-id="element-52">
            → GRATIS HOY
          </p>
        </div>
      </div>
    </section>;
}